/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Ranking,
} from '../models/index';
import {
    RankingFromJSON,
    RankingToJSON,
} from '../models/index';

export interface GetRankingRequest {
    trId: number;
}

/**
 * 
 */
export class RankingControllerApi extends runtime.BaseAPI {

    /**
     */
    async getRankingRaw(requestParameters: GetRankingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Ranking>>> {
        if (requestParameters['trId'] == null) {
            throw new runtime.RequiredError(
                'trId',
                'Required parameter "trId" was null or undefined when calling getRanking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ranking/{trId}`.replace(`{${"trId"}}`, encodeURIComponent(String(requestParameters['trId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RankingFromJSON));
    }

    /**
     */
    async getRanking(requestParameters: GetRankingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Ranking>> {
        const response = await this.getRankingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
